function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
import classnames from 'classnames';
import Icons from "./icons";
import styles from "./Icon.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var Icon = function Icon(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? '' : _ref$fill,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '' : _ref$height,
    type = _ref.type,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '' : _ref$width,
    _ref$noFill = _ref.noFill,
    noFill = _ref$noFill === void 0 ? false : _ref$noFill;
  var iconStyle = {
    width: width
  };
  if (fill !== '') iconStyle.color = fill;
  if (height !== '') iconStyle.height = height;
  var IconType = Icons[type];
  return /*#__PURE__*/_jsx("span", {
    className: classnames({
      [styles.iconWrapper]: !noFill
    }, className),
    "data-e2e-name": "icon",
    style: _objectSpread({
      fontSize: width
    }, iconStyle),
    children: type && /*#__PURE__*/_jsx(IconType, {})
  });
};